import { createStore, applyMiddleware } from 'redux'
import { asyncAwaitThunk } from '../middleware/asyncAwaitThunk'
import rootReducer from '../reducers'

const configureStore = preloadedState =>
  createStore(rootReducer, preloadedState, applyMiddleware(asyncAwaitThunk))

export default new configureStore()



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js